import callApiAxiosClient from '../../axios/axios_client';
import { categoryList } from '../../models';

async function addCategories(items: categoryList): Promise<categoryList> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<categoryList>({
    method: 'post',
    url: 'categories',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    data: items,
  });
}

export default addCategories;
